import { render, staticRenderFns } from "./CenteredImageAndTextModule.vue?vue&type=template&id=f3366fae&scoped=true&"
import script from "./CenteredImageAndTextModule.vue?vue&type=script&lang=js&"
export * from "./CenteredImageAndTextModule.vue?vue&type=script&lang=js&"
import style0 from "./CenteredImageAndTextModule.vue?vue&type=style&index=0&id=f3366fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3366fae",
  null
  
)

export default component.exports